export function getRequestUri() {
    return window.location.pathname + window.location.search + window.location.hash
}
